import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-31ef61c0")

_pushScopeId("data-v-31ef61c0")
const _hoisted_1 = { class: "qualifications-wrapper flex flex--width flex--v flex--valign-c flex--gap-50" }
const _hoisted_2 = { class: "qualifications-buttons flex flex--width flex--halign-c flex--wrap flex--gap-10" }
const _hoisted_3 = { class: "qualfications-info-text text text--uppercase text--primary-b text--size-22 text--semi-bold text--center" }
const _hoisted_4 = { class: "qualfications-info-text text text--accent-gray-b text--size-20 text--height-24 text--medium text--center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SelectableButton = _resolveComponent("SelectableButton")
  const _component_MainPage = _resolveComponent("MainPage")

  return (_openBlock(), _createBlock(_component_MainPage, {
    title: _ctx.$trans('navigation.nav_qualifications'),
    "title-id": "qualifications-page",
    gap: true
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.qualificationGroups, (group) => {
            return (_openBlock(), _createBlock(_component_SelectableButton, {
              key: group.id,
              title: _ctx.$trans('qualifications.' + group.name).toUpperCase(),
              circular: true,
              primary: true,
              selected: _ctx.selectedGroupId === group.id,
              onClick: ($event: any) => (_ctx.selectedGroupId = group.id)
            }, null, 8, ["title", "selected", "onClick"]))
          }), 128))
        ]),
        _createVNode(_Transition, {
          name: "generic-fade",
          mode: "out-in"
        }, {
          default: _withId(() => [
            (_ctx.selectedGroup)
              ? (_openBlock(), _createBlock("div", {
                  key: _ctx.selectedGroupId,
                  class: "qualifications-info-wrapper flex flex--v flex--valign-c flex--gap-50"
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedGroup.qualifications, (qualification) => {
                    return (_openBlock(), _createBlock("div", {
                      key: qualification.id,
                      class: "qualifications-info flex flex--v flex--valign-c flex--gap-15"
                    }, [
                      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$trans("qualifications." + qualification.name)), 1),
                      _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$trans("qualifications." + qualification.name + "_description")), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["title"]))
})